import React from 'react';
import PropTypes from 'prop-types';

export default class DefaultPlaceholder extends React.Component {
  static displayName = 'GoogleTranslate-DefaultPlaceholder';
  static propTypes = {
    text: PropTypes.string,
  };

  static defaultProps = {
    text: 'Translate...',
  };

  render() {
    return (
      <div className="GoogleTranslate-DefaultPlaceholder">
        {this.props.text}
      </div>
    );
  }
}
